import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/store";

import { PasswordMisuseTab } from "./types";

interface PasswordMisuseState {
  selectedDomainId: number | null;
  selectedAlertIds: number[];
  activeTab: PasswordMisuseTab;
}

const initialState: PasswordMisuseState = {
  selectedDomainId: null,
  selectedAlertIds: [],
  activeTab: "phishing",
};

const passwordMisuseSlice = createSlice({
  name: "passwordMisuse",
  initialState,
  reducers: {
    selectDomain: (state, action: PayloadAction<number | null>) => {
      state.selectedDomainId = action.payload;
      state.selectedAlertIds = [];
    },
    selectAlert: (state, action: PayloadAction<number>) => {
      state.selectedAlertIds.push(action.payload);
    },
    unselectAlert: (state, action: PayloadAction<number>) => {
      state.selectedAlertIds = state.selectedAlertIds.filter(
        (id) => id !== action.payload,
      );
    },
    setSelectedAlerts: (state, action: PayloadAction<number[]>) => {
      state.selectedAlertIds = action.payload;
    },
    clearSelection: (state) => {
      state.selectedAlertIds = [];
    },
    setActiveTab: (state, action: PayloadAction<PasswordMisuseTab>) => {
      state.activeTab = action.payload;
      state.selectedDomainId = null;
      state.selectedAlertIds = [];
    },
  },
});

export const selectSelectedDomainId = (state: RootState) =>
  state.passwordMisuse.selectedDomainId;
export const selectSelectedAlertIds = (state: RootState) =>
  state.passwordMisuse.selectedAlertIds;
export const selectActiveTab = (state: RootState) =>
  state.passwordMisuse.activeTab;

export const {
  selectDomain,
  selectAlert,
  unselectAlert,
  setSelectedAlerts,
  clearSelection,
  setActiveTab,
} = passwordMisuseSlice.actions;

export const passwordMisuseReducer = passwordMisuseSlice.reducer;
